import React from 'react';
import LateralMenu from '../LateralMenu';
import { faClipboardList, faIdBadge, faSearch, faTag, faTriangleExclamation, faUserLock } from '@fortawesome/free-solid-svg-icons';
import { translate } from '../../services/translate';
import logo from '../../../assets/logo_facial.png';
import collapsedLogo from '../../../assets/icon_facial.png';

export default function FacialLateralMenu({ navigation, open, authenticatedUser, setOpen, selectedMenu }: LateralMenuProps) {

    return (
        <LateralMenu
            topImage={logo}
            collapsedTopImage={collapsedLogo}
            open={open}
            authenticatedUser={authenticatedUser}
            setOpen={setOpen}
            items={[{
                icon: faClipboardList,
                text: translate('liveEvents'),
                action: () => navigation.navigate('Facial', { screen: 'LiveEvents' }),
                selected: selectedMenu == 'live-events',
                omit: !(
                    authenticatedUser?.isAdmin
                    || authenticatedUser?.permissions.facial_module_access
                    || authenticatedUser?.permissions.facial_can_watch_all_events
                    || authenticatedUser?.permissions.facial_events_missing_person
                    || authenticatedUser?.permissions.facial_events_wanted_person
                ),
            }, {
                icon: faTriangleExclamation,
                text: translate('liveAlerts'),
                action: () => navigation.navigate('Facial', { screen: 'LiveAlerts' }),
                selected: selectedMenu == 'live-alerts',
                omit: !(
                    authenticatedUser?.isAdmin
                    || authenticatedUser?.permissions.facial_module_access
                    || authenticatedUser?.permissions.facial_can_watch_all_events
                    || authenticatedUser?.permissions.facial_alerts_missing_person
                    || authenticatedUser?.permissions.facial_alerts_wanted_person
                ),
            }, {
                icon: faSearch,
                text: translate('search'),
                action: () => navigation.navigate('Facial', { screen: 'Search' }),
                selected: selectedMenu == 'search',
                omit: !(authenticatedUser?.isAdmin
                    || authenticatedUser?.permissions.facial_module_access
                    || authenticatedUser?.permissions.facial_can_watch_all_events
                    || authenticatedUser?.permissions.facial_alerts_missing_person
                    || authenticatedUser?.permissions.facial_alerts_wanted_person
                    || authenticatedUser?.permissions.facial_events_missing_person
                    || authenticatedUser?.permissions.facial_events_wanted_person
                ),
            }, {
                icon: faIdBadge,
                text: translate('facialRegistration'),
                action: () => navigation.navigate('Facial', { screen: 'PeopleList' }),
                selected: selectedMenu == 'people',
                omit: !(
                    authenticatedUser?.isAdmin
                    || authenticatedUser?.permissions.facial_module_access
                    || authenticatedUser?.permissions.manage_missing_person
                    || authenticatedUser?.permissions.manage_wanted_person
                ),
            }, {
                icon: faTag,
                text: translate('tags'),
                action: () => navigation.navigate('Facial', { screen: 'Markers' }),
                selected: selectedMenu == 'markers',
                omit: !(
                    authenticatedUser?.isAdmin
                    || authenticatedUser?.permissions.facial_module_access
                    || authenticatedUser?.permissions.facial_manage_tags
                ),
            }, {
                icon: faUserLock,
                text: translate('ignoredList'),
                action: () => navigation.navigate('Facial', { screen: 'IgnoredPeople' }),
                selected: selectedMenu === 'ignored-people',
                omit: !(authenticatedUser?.isAdmin
                    || authenticatedUser?.permissions.facial_module_access)
            }]}
        />
    );
}
